// Build-host catch-all target (2026-10 staging fix). On the dedicated Build host every
// "/build/..." path (e.g. the Google callback's "/build/me" landing, or "/build/login?error=...")
// has no route of its own, so it reaches the catch-all. Strip the "/build" prefix there and keep
// the query/hash, instead of always sending the visitor to /login. Any other unknown path still
// goes to /login, exactly as before.
export function buildHostFallbackPath(pathname = "", search = "", hash = "") {
  if (pathname === "/build" || pathname.startsWith("/build/")) {
    return (pathname.replace(/^\/build/, "") || "/login") + search + hash;
  }
  return "/login";
}
